module.exports = __webpack_public_path__ + "img/logo.e7a281c6.svg";